
import { gql } from '@apollo/client';

export const LIST_TAGS = gql`
    query list_tags($data: ListTagsInputType) {
        list_tags(data: $data) {
            hasError
            data
            message
        }
    }
`;

export const CREATE_TAGS = gql`
  mutation create_tags($data: CreateTagsInputType) {
    create_tags(data: $data) {
        hasError
        data
        message
    }
}
`;

export const DELETE_TAGS = gql`
 mutation delete_tags($data: DeleteTagsInputType) {
    delete_tags(data: $data) {
        hasError
        data
        message
    }
}
`;


export const EDIT_TAGS = gql`
 mutation update_tags($data: UpdateTagsInputType) {
    update_tags(data: $data) {
        hasError
        data
        message
    }
}
`;

 